import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import { SearchRounded } from '@material-ui/icons';
import { BACKGROUND_DARK } from '../../const/color-const';

const styles = theme => ({
  button: {
    overflow: 'hidden',
    margin: theme.spacing(1),
    padding: `${theme.spacing(1)}px ${theme.spacing(3)}px`,
    fontSize: 16,
    textTransform: 'initial',
    boxShadow: theme.palette.type === 'light' ? 'none' : 'inset 0px 0px 15px 5px rgba(0,0,0,0.25)',
  },
  buttonAnimated: {
    transition: theme.transitions.create('transform'),
    '&:hover': {
      transform: `translateY(-${theme.spacing(1)}px)`,
    },
  },
  searchButton: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      justifyItems: 'flex-start',
      justifyContent: 'flex-start',
    },
    justifyContent: 'flex-start',
    padding: theme.spacing(0, 3, 0, 3),
    position: 'relative',
    width: 160,
    height: 54,
    '&::after': {
      position: 'absolute',
      height: 100,
      width: 200,
      left: 46,
      top: -40,
      zIndex: 1,
      content: '""',
      display: 'block',
      transformOrigin: 'center',
      transform: 'rotate(70deg)',
      background: 'rgba(255,255,255,0.15)',
      transition: 'transform 130ms ease-in',
    },
    '&:hover': {
      '&::after': {
        transform: `rotate(70deg) translateY(-80px)`,
      },
    },
  },
  searchIcon: {
    color: BACKGROUND_DARK,
    position: 'absolute',
    fontSize: 22,
    left: '75%',
  },
});

const CommonButton = ({
                        classes,
                        label,
                        size,
                        onClick,
                        startIcon,
                        endIcon,
                        type,
                        disabled,
                        isAnimated,
                        searchButton,
                        ...rest
                      }) => {
  const buttonSize = size || 'medium';
  
  return (
    <Button
      {...rest}
      classes={{
        root: classNames(classes.button,
          isAnimated && classes.buttonAnimated,
          searchButton && classes.searchButton),
      }}
      size={buttonSize}
      type={type}
      disabled={disabled}
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
    >
      {label}
      {searchButton && <SearchRounded className={classes.searchIcon} />}
    </Button>
  );
};

CommonButton.propTypes = {
  classes: PropTypes.object,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  color: PropTypes.string,
  size: PropTypes.string,
  onClick: PropTypes.func,
  variant: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  isAnimated: PropTypes.bool,
};

CommonButton.defaultProps = {
  color: 'primary',
  variant: 'contained',
};

export default withStyles(styles)(CommonButton);
